import classNames from 'classnames';
import { FC, ReactNode } from 'react';

import { NullValueGuard } from '@/middlewares/NullValueGuard';

import { ConditionView } from '../ConditionView/ConditionView';
import { DangerousHTML } from '../DangerousHTML/DangerousHTML';
import { Informer, InformerProps } from '../Informer';
import { Typography } from '../Typography';

import './Grid.scss';

interface GridBaseProps {
  className?: string;
  title?: string;
  informer?: InformerProps;
  placeholder?: string;
  isHtmlData?: boolean;
}

interface CommonGridProps extends GridBaseProps {
  data: Array<[string, Nullable<string | ReactNode>]>;
  isHtmlData?: false;
}

interface GridPropsWithHtmlData extends GridBaseProps {
  data: Array<[string, Nullable<string>]>;
  isHtmlData?: true;
}

export type GridProps = CommonGridProps | GridPropsWithHtmlData;

export const Grid: FC<GridProps> = ({
  className,
  title,
  data,
  informer,
  placeholder = 'Не вказано',
  isHtmlData = false,
}) => {
  return (
    <div data-testid="grid" className={classNames('custom-grid', className)}>
      {title && (
        <div data-testid="grid-header" className="custom-grid__header">
          <Typography variant="H4" className="custom-grid__header-title">
            {title}
          </Typography>
        </div>
      )}
      <div data-testid="grid-body" className="custom-grid__body">
        {informer && (
          <div className="custom-grid__body-informer">
            <Informer {...informer} />
          </div>
        )}
        {data.map(([key, value]) =>
          key ? (
            <div key={key} className="custom-grid__columns">
              <div className="custom-grid__row">
                <div className="custom-grid__col">
                  <Typography color="graphite" className="custom-grid__title">
                    {key}
                  </Typography>
                  <div className="custom-grid__info">
                    <ConditionView
                      if={isHtmlData}
                      else={
                        <Typography className="custom-grid__value" color={value ? 'black' : 'grey'}>
                          <NullValueGuard placeholder={placeholder}>{value}</NullValueGuard>
                        </Typography>
                      }
                    >
                      <Typography as="div" className="custom-grid__value" color={value ? 'black' : 'grey'}>
                        <DangerousHTML content={(value as string) ?? placeholder} />
                      </Typography>
                    </ConditionView>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <></>
          ),
        )}
      </div>
    </div>
  );
};
